import { Container } from 'components/container';
import { useDataContext } from 'context/data-context';
//import { useAppContext } from 'context/app-context';
import { FC, useEffect, useRef, useState } from 'react';

import { Logo as LogoUz } from './logo-uz';
import { Logo as LogoRu } from './logo-ru';
import { Menu } from './menu';
import { Search } from './search';
import { Share } from './share';
import { StyledHeader, Logo, LogoContainer, MenuContainer, ObservedPoint } from './styled';

export const Header: FC<{ onTop?: boolean }> = ({ onTop }) => {
  const { appLocale } = useDataContext();
  const pointRef = useRef<HTMLDivElement>(null);
  const [isShareOpen, setIsShareOpen] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  const toggleShare = () => setIsShareOpen((v) => !v);

  useEffect(() => {
    const observer = new IntersectionObserver(([point]) => {
      setHasScrolled(!point.isIntersecting);
    });

    if (pointRef.current) {
      observer.observe(pointRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <ObservedPoint ref={pointRef} />
      <StyledHeader $onTop={onTop} hasScrolled={hasScrolled}>
        <Container>
          <LogoContainer href="/">
            <Logo as={appLocale === 'uz' ? LogoUz : LogoRu} />
          </LogoContainer>

          <Search />

          <MenuContainer isShareOpen={isShareOpen}>
            <Menu />
          </MenuContainer>

          <Share isOpen={isShareOpen} onToggle={toggleShare} />
        </Container>
      </StyledHeader>
    </>
  );
};
